export const WATCH_PLAYLIST = 'hosted-watch-playlist';
export const WATCH_DEEP_SEARCH = 'hosted-watch-deep-search';
export const WATCH_COMMENTS = 'hosted-watch-comments';
export const WATCH_SLIDES = 'hosted-watch-slides';
export const WATCH_CHAPTERS = 'hosted-watch-chapters';
export const WATCH_TRANSCRIPTS = 'hosted-watch-transcripts';
export const WATCH_DOWNLOAD_VIDEO = 'hosted-watch-download-video';

export const VIDEO_ALL_TAB = 'video-all-tab';
export const VIDEO_MY_TAB = 'video-my-tab';
export const VIDEO_SHARED_TAB = 'video-shared-tab';

export const PCN_PUT_VIDEO = 'put/video';

export const VIDEO_SHARE = 'video-share';
export const VIDEO_EXTERNAL_SHARE = 'video-external-share';

export const GET_INVITATIONS = 'get/invitations';
export const POST_INVITATIONS = 'post/invitations';
export const DELETE_INVITATIONS = 'delete/invitations';
